import React from "react"
import {FieldEditableMode, FieldEditableProps} from "../../../../proto/render/editable";
import {FieldViewSize} from "../../../../const";
import EditableInput from "../inline-editable/input-component";
import {isBulkSelection} from "../../../../../gd/right-click-menu";
import GoogleApi from "../../../../../gd/api/google-api";
import Addresses from "../../../../../model2/address/addresses";

const debug = false
// const debug = "FieldAddress_Editable"

type State = {
    initialPropsValue?  : any
    currentOption?      : any
    showPopover         : boolean
    mode                : FieldEditableMode
    inputValue          : string
    options             : Option[]
}

export default class FieldAddress_Editable extends React.Component<FieldEditableProps, State> {

    constructor(props: FieldEditableProps) {
        super(props);

        const value = this.props.field.getViewValue(this.props.model)

        this.state = {
            currentOption       : value?.place,
            showPopover         : false,
            mode                : FieldEditableMode.VIEW,
            inputValue          : value?.description,
            options             : []
        }
    }

    hidePopover = () => {
        if (this.state.showPopover) {
            this.setState({showPopover: false, mode: FieldEditableMode.VIEW})
        }
    }

    onImmediateChange = async (value: string) => {

        this.setState({inputValue: value});

        if(value?.length > 0 && this.state.options.length > 0){
            this.setState({showPopover: true})
        }
        else{
            this.setState({showPopover: false})
        }

        try{
            const response: any = await GoogleApi.searchPlaces(this.state.inputValue)

            debug && console.log(debug, "Response?", response)

            const addressCollection = Addresses.initFromJson(response?.suggestions)

            this.setState({options: addressCollection.toOptions()})
        }
        catch(e){
            console.error(e)
        }
    };

    onMouseEnter = () => {
        if (this.props.disabled || !this.props.field.canEdit(this.props.model)) return false

        this.setState({mode: FieldEditableMode.HOVERED})
    }

    onMouseLeave = () => {
        this.setState({mode: FieldEditableMode.VIEW})
    }

    onBlur = ()=>{

        if(!this.state.showPopover || this.state.options.length === 0){
            this.setState({mode: FieldEditableMode.VIEW})
        }
    }

    onClick = (e: React.MouseEvent) => {

        if (this.props.disabled || !this.props.field.canEdit(this.props.model)) return false

        this.setState({mode: FieldEditableMode.EDITING})
    }

    onDeleteClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) return
        e.stopPropagation()

        this.onChange(null)
    }

    onChange = (newValue:any) => {

        this.setState({currentOption: newValue?.place})

        this.props.onChange && this.props.onChange(newValue)

        this.setState({showPopover: false, mode: FieldEditableMode.VIEW, options: []})

    }

    onOptionClick = (option: Option)=>{

        debug && console.log(debug, "Option?", option)

        if(option.value.placeId.length > 0){
            this.onChange({
                isValid: true,
                place: option.value
            })
        }
    }

    getClasses = ()=>{

        return  Classes("ui5-field-editable", this.props.className, {
            "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
        })
    }

    renderValue = (displayValue: string)=>{

        return (
            <div className="flex-row-left-center txt-truncate">
                {displayValue && <div className="i5-location ui5-ico-16 m-r-5"></div>}
                <div className="txt-truncate">
                    {displayValue}
                </div>
            </div>
        )
    }

    renderEditing = () => {
        const value              = this.props.field.getViewValue(this.props.model)
        const displayValue       = this.props.field.getDisplayValue(value)
        const field   = this.props.field
        this.props.field.options = this.state.options

        return (
            <>
                <EditableInput className         = "ui5-txt-default ui5-field-form-editable w-100-percent h-36" // p-l-10 p-r-10
                               inputClassName    = "ui5-txt-default"
                               value             = {displayValue}
                               focusOnMount      = {true}
                               placeholder       = {this.props.field.placeholder}
                               onImmediateChange = {this.onImmediateChange}
                               onBlur            = {this.onBlur}/>
                {this.state.showPopover  && (
                    <field.components.PopoverMenu parent = {this}
                                                  field  = {this.props.field}
                                                  model  = {this.props.model}/>
                )}
            </>
        )
    }

    renderHovered = () => {

        const hoveredClasses = Classes(this.getClasses(), "is-hovered", "w-100-percent")

        const value = this.props.field.getViewValue(this.props.model)
        const displayValue = this.props.field.getDisplayValue(value)

        return (
            <div className    = {hoveredClasses}
                 onClick      = {this.onClick}
                 onMouseLeave = {this.onMouseLeave}>

                {this.renderValue(displayValue)}

                <div className="buttons">
                    {!!displayValue && <div className="btn-reset" onClick={this.onDeleteClick}/>}
                </div>
            </div>
        )
    }

    renderView = () => {

        const value         = this.props.field.getViewValue(this.props.model)
        const displayValue  = this.props.field.getDisplayValue(value)

        return (
            <div className={this.getClasses()}
                 onMouseEnter={this.onMouseEnter}
                 onClick={this.onClick}>
                <div className="flex-row-left-center max-w-100-percent">

                    {this.renderValue(displayValue)}

                </div>
            </div>
        )
    }

    render() {

        switch (this.state.mode) {
            case FieldEditableMode.EDITING:
                return this.renderEditing()

            case FieldEditableMode.HOVERED:
                return this.renderHovered()

            case FieldEditableMode.VIEW:
            default:
                return this.renderView()
        }
    }
}
